export const cargoTypeConstants = {
    CARGO_TYPE_FETCHING: 'CARGO_TYPE_FETCHING',
    CARGO_TYPE_FETCHED: 'CARGO_TYPE_FETCHED',
    CARGO_TYPE_SUBMITTING: 'CARGO_TYPE_SUBMITTING',
    CARGO_TYPE_SUBMITTED: 'CARGO_TYPE_SUBMITTED',
    GET_CARGO_TYPES: 'GET_CARGO_TYPES',
    GET_CARGO_TYPE_BY_ID: 'GET_CARGO_TYPE_BY_ID',
    GET_ACTIVE_CARGO_TYPES: 'GET_ACTIVE_CARGO_TYPES',
}